import {
  CLEAR_PENDING_BATCHES,
  CLEAR_PENDING_WITHDRWAL_REQUEST,
  GET_PENDING_BATCHES,
  GET_PENDING_WITHDRAWL_REQUEST,
} from "../actions/notification";

const initialState = {
  withdrawlRequestData: [],
  pendingBatchesData: [],
};
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_PENDING_WITHDRAWL_REQUEST:
      return { ...state, withdrawlRequestData: action.payload };

    case CLEAR_PENDING_WITHDRWAL_REQUEST:
      return { ...state, withdrawlRequestData: [] };

    case GET_PENDING_BATCHES:
      return { ...state, pendingBatchesData: action.payload };

    case CLEAR_PENDING_BATCHES:
      return { ...state, pendingBatchesData: [] };

    default:
      return state;
  }
};
